import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { RutFormat, formatRut } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Clients } from 'src/app/models/interfaces/clients';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';

@Component({
  selector: 'app-add-store',
  templateUrl: './add-store.component.html',
  styleUrls: ['./add-store.component.css']
})
export class AddStoreComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }
  ngOnInit(): void {
    this.getFacility();
    if (this.data != null) {
      this.primaryForm.patchValue(this.data);
    }
  }
  /**
   * Hago referencia a la ventana actual
   */
  @Input()
  modalRef: NgbModalRef | undefined;

  @Input()
  data: any=null;
  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Clients>();
  items: any;
  
  primaryForm = new UntypedFormGroup({
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(),
    owner: new UntypedFormControl(''),
    owner_phone: new UntypedFormControl(''),
    facility_id: new UntypedFormControl(0),
    rut: new UntypedFormControl(''),
    turn: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    hide_rounds: new UntypedFormControl(false),
  });
  facilitys: Facility[];
  create() {
    this.api.createStore(this.primaryForm).subscribe(
      (response) => {
        this.toast.success('Recinto creado correctamente', 'Gestión Bodegas');
        this.record.emit(response.data as Clients);
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }

      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error');
      }
    );
  }
  getFacility() {
    this.api.getAllFacility().subscribe((res) => {
      this.facilitys = res.data as Facility[];
    });
  }
  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.primaryForm
        .get('rut')
        ?.setValue(rut);
    } 
  }
  openModal(md: any, size = 'md') {
    this.modalRef=this.modal.open(md, {
      size: size,
    });
  }
  hideRounds(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.primaryForm.get('hide_rounds')?.setValue(value);
    console.log("checked:",checked);
    console.log("value:",value);
  }
}
